<template>
  <div class="header">
    <slot>
      <p>I'm the default header content</p>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'c-header',
};
</script>

<style lang="scss" scoped>
@import "../main.scss";
.header {
  font-size: 1.4rem;
  height: 7rem;
  min-width: 1200px;
  max-width: 2880px;
  background-color: #212121;
  border-bottom: var(--line);

  display: grid;
  grid-template-columns: 320px 5fr 1fr;
  grid-template-rows: 7rem;

  & > div {
    align-self: center;
  }

  &__user-photo {
    height: 3.75rem;
    border-radius: 50%;
    margin-right: 1rem;
  }

  @media only screen and (max-width: $bp-smallest) {
    flex-wrap: wrap;
    height: 11rem;
    align-content: space-around;
  }
}
</style>
